import { campaignTemplatesConstants } from '@constants/campaignTemplates';

const initialState = {
    data: [],
    loading: true,
    error: '',
};

export function campaignTemplates(state = initialState, action) {
    switch (action.type) {
        case campaignTemplatesConstants.CAMPAIGN_TEMPLATES_FETCH:
            return { ...state, loading: true, error: '' };
        case campaignTemplatesConstants.CAMPAIGN_TEMPLATES_SUCCESS:
            return { ...state, loading: false, data: action.data, error: '' };
        case campaignTemplatesConstants.CAMPAIGN_TEMPLATES_ERROR:
            return { ...state, error: action.message, loading: false };
        default:
            return state;
    }
}
